module.exports = __webpack_public_path__ + "assets/c4386d3dbb24b56e4611ca7b1ff29388.png";